import { Component, OnInit } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { EntertainmentService } from '../entertainment.service';
import { SelectionInfo } from 'src/app/post-login/selectors/multi-selection/multi-selection.model';
import { HaloToastService, EToastType } from 'src/app/core/halo-toast/halo-toast.service';
import { HaloCustomLoaderErrorType } from 'src/app/core/halo-custom-loader/halo-custom-loader.service';
import { environment } from '../../../../../../src/environments/environment';
import { ZENDESK_ARTICLES } from 'src/app/core/data/constants';
@Component({
  selector: 'app-entertainment-app',
  templateUrl: './entertainment-app.component.html',
  styleUrls: ['./entertainment-app.component.scss']
})
export class EntertainmentAppComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  activatedComponentRef: any;
  active: number;
  haloWebCloudURL: string = environment.haloWebCloudBasePath;
  selectionInfo: SelectionInfo;
  hasEditPermission = false;
  showPublishModal: boolean = false;
  appEntertainmentData: {allSelected:string,appList:[],consoleType:string,publishedAtmillis:string,enterTainmentAppsList:any,gamesAppsList:any,newsAppsList:any};
  customLoaderIsLoading = false;//customLoaderIsLoading for customSpinner.
  customLoaderErrorMsg:string;
  customLoaderRedirectButtonLabel:string;
  customLoaderRedirectButtonUrl:string;
  publishedPopupProperties = {
    title: this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENTERTAINMENT.APPS.ON.CONSOLE', [""]),
    message: this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENTERTAINMENT.APPS.ON.CONSOLE.DESCRIPTION', [""]),
    additionalTitleNMessage:[],
    isWarningPopup: false,
    ctaButtonLabel: 'PUBLISH',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
  };
  private sub = new Subscription();
  zendeskArticles = ZENDESK_ARTICLES;
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private _commonUtil: CommonUtil,
    private _entertainmentService: EntertainmentService,
    private _toast: HaloToastService
  ) { }

  ngOnInit(): void {
  }
  
  onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      if(selectionInfo){
        this.selectionInfo = selectionInfo;
        this.hasEditPermission = this.selectionInfo.facility.summary?.isLoggedInManagerAdmin === 'true' || this.selectionInfo.facility.summary?.userRights.customize === 'F';
        let consoleRights = this._commonUtil.rootScopeData?.consoleRights?.get(this.selectionInfo.consoleType);
        if(consoleRights.hasInternetSetting === 'true'){
          this.getAppEntertainmentData();
        }
      }
    });
  }

  async getAppEntertainmentData() {
    this.customLoaderIsLoading = true;
    var payload = { "facilityId": this.selectionInfo.facility.facilityId.split(',')[0], "consoleType": this.selectionInfo.consoleType };
    try{
      let resp: any = await this._entertainmentService.getAppsEntertainmentData(payload);
      this.customLoaderIsLoading = false;
      if (resp) {
        this.appEntertainmentData = resp; 
        this.appEntertainmentData.enterTainmentAppsList =  this.appEntertainmentData.appList.filter((val:any) => val.categoryId === "1");
        this.appEntertainmentData.gamesAppsList =  this.appEntertainmentData.appList.filter((val:any) => val.categoryId === "2"); 
        this.appEntertainmentData.newsAppsList =  this.appEntertainmentData.appList.filter((val:any) => val.categoryId === "3"); 
        this.refrestAllAppsSelectedStatus();
      }
    }catch(error){
      this.customLoaderErrorMsg =  HaloCustomLoaderErrorType.APIFAILED;
    }
 
  }

  onSelectAll(){
    this.appEntertainmentData.allSelected = this.appEntertainmentData.allSelected === 'true'?'false':'true';
    this.appEntertainmentData.enterTainmentAppsList.map((val:any)=> val.isEnabled = this.appEntertainmentData.allSelected);
    this.appEntertainmentData.gamesAppsList.map((val:any)=> val.isEnabled = this.appEntertainmentData.allSelected);
    this.appEntertainmentData.newsAppsList.map((val:any)=> val.isEnabled = this.appEntertainmentData.allSelected);
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
  }

  onSelect(appName:any){
    appName.isEnabled = appName.isEnabled === "true"?"false":"true";
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    this.refrestAllAppsSelectedStatus();
  }

  refrestAllAppsSelectedStatus(){
    let isAllEntertainmentAppListSelected = this.appEntertainmentData.enterTainmentAppsList.find((val:any)=> val.isEnabled === "false");
    let isAllGamesAppListSelected = this.appEntertainmentData.gamesAppsList.find((val:any)=> val.isEnabled === "false");
    let isAllNewsAppListSelected = this.appEntertainmentData.newsAppsList.find((val:any)=> val.isEnabled === "false");
    if(isAllEntertainmentAppListSelected || isAllGamesAppListSelected || isAllNewsAppListSelected){
      this.appEntertainmentData.allSelected = "false";
    }else{
      this.appEntertainmentData.allSelected = "true";
    }
  }

  validateIsAppSelected(){
    let isEntertainmentAppSelected = this.appEntertainmentData.enterTainmentAppsList.find((val:any)=> val.isEnabled === "true");
    let isGamesAppSelected = this.appEntertainmentData.gamesAppsList.find((val:any)=> val.isEnabled === "true");
    let isNewsAppSelected = this.appEntertainmentData.newsAppsList.find((val:any)=> val.isEnabled === "true");
    if(isEntertainmentAppSelected || isGamesAppSelected || isNewsAppSelected){
      return true;
    }else{
      return false;
    }
  }

  prepareSeletedPopupMessage(){
    let titleNMessage = [];
    let entertainmentApps = this.appEntertainmentData.enterTainmentAppsList.filter((val:any)=> val.isEnabled === "true");
    let gameApps = this.appEntertainmentData.gamesAppsList.filter((val:any)=> val.isEnabled === "true");
    let newApps = this.appEntertainmentData.newsAppsList.filter((val:any)=> val.isEnabled === "true");
    if(entertainmentApps.length>0){
      titleNMessage.push({
        "title":"Entertainments",
        "message":entertainmentApps.map((val:any) => val.name)
      });
    }
    if(gameApps.length>0){
      titleNMessage.push({
        "title":"Games",
        "message":gameApps.map((val:any) => val.name)
      });
    }
    if(newApps.length>0){
      titleNMessage.push({
        "title":"News",
        "message":newApps.map((val:any) => val.name)
      });
    }
    return titleNMessage;
  }

  publishApps(){
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true;
    if(this.validateIsAppSelected()){
      this.publishedPopupProperties.message = this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENTERTAINMENT.APPS.ON.CONSOLE.DESCRIPTION', [""]);
      this.publishedPopupProperties.additionalTitleNMessage =this.prepareSeletedPopupMessage() as any;
    }else{
      this.publishedPopupProperties.message = this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENTERTAINMENT.NO.APPS.ON.CONSOLE.DESCRIPTION', [""]);
      this.publishedPopupProperties.additionalTitleNMessage = [];
    }
    this.showPublishModal = true;
  }

  onPublishConfirmation() {
    this.showPublishModal = false;
    this.publishAppsEntertainment();
  }

  async publishAppsEntertainment() {
    this.customLoaderIsLoading = true;
    let listToPublish=[];
    let convertAppItem = (item: any) => {
      if(item.appId) return {"appId":item.appId,"appType":item.appType,"categoryId":item.categoryId,"displayOrder":item.displayOrder,"isEnabled":item.isEnabled,"name":item.name,"packageName":item.packageName}
      return {"configAppId":item.configAppId,"isEnabled":item.isEnabled,"name":item.name}
    }
    let enterTainmentAppsList = this.appEntertainmentData.enterTainmentAppsList.map(convertAppItem);
    let gamesAppsList = this.appEntertainmentData.gamesAppsList.map(convertAppItem);
    let newsAppsList = this.appEntertainmentData.newsAppsList.map(convertAppItem);
    listToPublish = [...enterTainmentAppsList , ...gamesAppsList, ...newsAppsList];
    let payload = {"facilityId":this.selectionInfo.facility.facilityId.split(',')[0],"consoleType":this.selectionInfo.consoleType,"appList":listToPublish};	
    try {
      let resp: any = await this._entertainmentService.postAppsEntertainmentData(payload);
      this.customLoaderIsLoading = false;
      this.getAppEntertainmentData();
      var publishOkay = this._commonUtil.replaceValueAsHTMLOnTranslatedText('ENTERTAINMENT.TABS.PUBLISH.SUCCESS.MESSAGE', [this._commonUtil.translateText('APPS')]);
      this._toast.creatToast(this._commonUtil.replaceValueAsHTMLOnTranslatedText(publishOkay, []), EToastType.SUCCESS);
      this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = false;
    } catch (error) {
      this.customLoaderErrorMsg =  HaloCustomLoaderErrorType.APIFAILED;
    }
	}

  closePublishedModal() {
    this.showPublishModal = false;
  }

  learnMore() {
    window.open(this.zendeskArticles.FACILITY_CONNECT_APPS_PAGE_OVERVIEW, '_blank');
  }

  ngOnDestroy(): void {
  }

}
